import React, {useState, useEffect} from "react";
import {useNavigate, useLocation, Link} from "react-router-dom";
import axios from "axios";
import  {access_golfer, update_golfer_access} from "../../API/APICalls";
import ContactUSGA from "../ContactUSGA";



export default function LoginForm() {

    const navigate = useNavigate();
    const location = useLocation();

    const [inputs, setInputs] = useState({lastname: '', email: '', handicapID: ''});


    const [disable, SetDisable] = useState(false);
    const [disableemail, SetDisableEmail] = useState(false);
    const [required, setRequired] = useState(false);
    const [requiredemail, setRequiredEmail] = useState(true);
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) =>  setInputs(inputs => ({ ...inputs, [name]: value }));
    const [isLoading, setIsLoading] = useState(true);
    const [contactUSGA, setContactUSGA] = useState(false);
    const [error, setError] = useState('');
    


      const handleFields = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        
        if (event.currentTarget.value)
        {
            SetDisable(true);
        } else {
            SetDisable(false);
        }
    }

    const handleHandicap = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        
        if (event.currentTarget.value)
        {
            SetDisableEmail(true);
        } else {
            SetDisableEmail(false);
        }
    }

    
      const disableField = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        setInputs({... inputs, "email": event.currentTarget.value });
        
        if (inputs.email.length === 0)
        {
            
            SetDisable(false);
            setRequired(false);
            setRequiredEmail(false);
        } else {
            SetDisable(false);
            setRequired(true);
            setRequiredEmail(true);
        }
        
      }


     const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        const search_response = "";
        const search_cc_response = "";

        //search centralized computation for golfer lastname and email or handicap id
        const response = await access_golfer(inputs);

        if (response)
            {
                var status_code = JSON.parse(response);
                //console.log(JSON.parse(status_code.results[0].golfers.length));
                if (status_code.error?.message=="Request failed with status code 500")
                {
                  
                } else {

                    if (JSON.parse(response || '').message == "If a user account exists with this information, an email has been sent containing an OTP.")
                    {
                      
                        navigate('/membership/verify', {state: {email:inputs.email, handicap_id: inputs.handicapID}});
                        
                    } else {
                    
                        setIsLoading(false);
                        setError("The information you have entered is incorrect, please try again!")
                    }

                    // //if CC return golfers then trigger workflow to bring golfer into hubspot and generate code.
                    // if (JSON.parse(response || '').results[0].guardian.length > 0)
                    // {
                    //     setIsLoading(false);
                    //     setContactUSGA(true)
                    //     console.log("FOUND A GUARDIAN");
                    // } else if (JSON.parse(response || '').results[0].golfers.length > 0)
                    // {
                    //     console.log("Found existing golfer");
                    //     //trigger workflow to check if contact is in hubspot and then create 
                    //     //const new_cc_response = await update_golfer_access(inputs);
                    //     setIsLoading(false);
                    //     navigate('/membership/manage/verify', {state: ""});
                    // } else {
                    //     console.log("CONTINUE");
                    //     setIsLoading(false);
                    //     setError("The information you have entered is incorrect, please try again!")
                    //     //navigate('/personal-info', {state:{zipcode:zipcode, aga:agadata, inputs:inputs}});
                    // }
                }
            }
     }



     useEffect(() => {
        setIsLoading(false);
    }, []);


    return (<>
        <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Verify Your Identity</h1></div>

        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">   
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 py-3">
                   <p className="bg-light mt-3 mb-4 p-3 border rounded fs-5">If you have a Handicap ID, enter your last name and email or your Handicap ID.</p>
                </div>
                
                
                
                <form onSubmit={handleSubmit} name="Find Golfer">
                
              
                {isLoading ?
                    <div className="loaderWrapper">
                    <div className="loader"></div>
                    </div>
                    : <><div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-2">
                            <label className="form-label">Last Name*</label>
                            <input type="text" name="lastname" className="form-control" id="lastname" placeholder="" autoFocus  value={inputs.lastname} pattern="^[a-zA-Z\-\/\s']+|[^@$^%*&#!]+^[^\x20-\x7F]$" onChange={handleChange} required={true}/>
                        </div>

                        <div className="col-sm-12 col-md-12 col-lg-12 py-2">
                            <label className="form-label">Email Address{disable ? '*' : ''}</label>
                            <input type="email" name="email" className="form-control" id="email" placeholder="" value={inputs.email} onChange={handleChange} required={requiredemail} disabled={disableemail} onKeyUp={handleFields} pattern="[\-a-zA-Z0-9_+\}\{'?]+(\.[\-a-zA-Z0-9_+\}\{'?]+)*@[a-zA-Z0-9_][\-a-zA-Z0-9_]*(\.[\-a-zA-Z0-9_]+)*\.[a-zA-Z]*(:[0-9]{1,5})?" onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please Enter a Valid Email Address')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}/>
                        </div></>
                    }
                        
                     
                            <div className="col-sm-12 col-md-12 col-lg-12 py-2">
                                <label className="form-label">Handicap ID{disableemail ? '*' : ''}</label>
                                <input type="text" className="form-control" value={inputs.handicapID} id="handicapID" onChange={handleChange} placeholder="" name="handicapID"  disabled={disable} required={required} onKeyUp={handleHandicap}/>
                            </div>
                   
                    
                                           
                            <div className="col-12"><p className="text-danger">{error}</p></div>

                        {!contactUSGA ?
                        <div className="mt-4 col-12 col-sm-12 col-md-12 col-lg-9 col-lg-12">
                            <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 order-1 pt-3 ps-2">
                                <Link to="/" className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 order-sm-1 order-lg-1 pt-3">
                                <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                                    CONTINUE
                                </button>
                            </div>
                        </div>
                        </div>
                         : "SORRY!"}
                        
                        </form>
                        
                   
            </div>
            </div>
        </div>
        </>
    );

}